export const CustomPageTitle = ({ children, style, ...props }) => {
    return (
        <h1 {...props} style={{ fontSize: '1.5vw', color: "grey", ...style }}>{ children }</h1>
    )
}
